import React from 'react';
import RentReportingStatus from '../RentReportingStatus';
import CardLabelAndTitle from '../../../../components/CardLabelAndTitle';
import { CardDetails } from './LandLordDetailsCard.data';

import './styles.scss';

const LandLordDetailsCard = ({ payload, activeRentReportingStatus }: any) => {
  const rentCollectionDetails = CardDetails({ payload });

  return (
    <div className="wrapper">
      <h4 className="headText">Landlord’s Information</h4>
      {rentCollectionDetails?.map(({ attribute, label, id }) => (
        <CardLabelAndTitle
          key={id}
          content={payload}
          attribute={attribute}
          label={label}
          statusComponent={id === 1
            ? (
              <RentReportingStatus
                activeRentReportingStatus={activeRentReportingStatus}
              />
            ) : null}
        />
      ))}
    </div>
  );
};

export default LandLordDetailsCard;
